import { Outlet } from 'react-router-dom';
import './Layout.css';

export function Layout() {
  return (
    <div className="layout">
      <header className="layout-header">
        <a href="/" className="layout-logo">
          <svg width="28" height="28" viewBox="0 0 64 64" fill="none">
            <rect width="64" height="64" rx="14" fill="url(#logo-grad)" />
            <path d="M32 16c-5.5 0-10 4.5-10 10v6c0 5.5 4.5 10 10 10s10-4.5 10-10v-6c0-5.5-4.5-10-10-10z" stroke="white" strokeWidth="3" fill="none" />
            <path d="M22 30v2c0 5.5 4.5 10 10 10s10-4.5 10-10v-2" stroke="white" strokeWidth="3" strokeLinecap="round" fill="none" />
            <line x1="32" y1="42" x2="32" y2="48" stroke="white" strokeWidth="3" strokeLinecap="round" />
            <line x1="26" y1="48" x2="38" y2="48" stroke="white" strokeWidth="3" strokeLinecap="round" />
            <defs>
              <linearGradient id="logo-grad" x1="0" y1="0" x2="64" y2="64">
                <stop offset="0%" stopColor="#7c3aed" />
                <stop offset="100%" stopColor="#2563eb" />
              </linearGradient>
            </defs>
          </svg>
          <span className="layout-logo-text">SecretTalk</span>
        </a>
      </header>

      <main className="layout-main">
        <Outlet />
      </main>
    </div>
  );
}
